let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8S8NC")).then(() => parcelRequire('8xOat'));